import React, { forwardRef } from 'react';
import styled from 'styled-components';

const ImagesContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  transform-origin: center center;
  will-change: transform;

  &.stacked-container {
    position: absolute;
    left: 1.5vw;
    bottom: 1.5vw;
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    gap: 1vw;
    transform: none;
    will-change: transform;
  }
`;

const ImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(1.5);
  width: 100%;
  height: 100%;
  visibility: visible;
  will-change: transform;
  opacity: 0;

  &:first-child {
    opacity: 1;
  }

  &.stacked {
    position: relative;
    width: 8vw;
    height: 5vw;
    transform: none;
    top: auto;
    left: auto;
    opacity: 1;
    will-change: transform;
  }

  @media (max-width: 1200px) {
    &.stacked {
      width: 0;  /* Adjust width for smaller screens */
      height: 0;  /* Adjust height for smaller screens */
    }
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const Images = forwardRef((props, ref) => (
  
  <ImagesContainer className="images" ref={ref}>
    <ImageWrapper className="img"><StyledImage src='https://genzixbackend.s3.ap-south-1.amazonaws.com/img1.webp' alt="Image 1" /></ImageWrapper>
    <ImageWrapper className="img"><StyledImage src='https://genzixbackend.s3.ap-south-1.amazonaws.com/4.webp' alt="Image 2" /></ImageWrapper>
    {/* <ImageWrapper className="img"><StyledImage src={card3} alt="Image 3" /></ImageWrapper>
    <ImageWrapper className="img"><StyledImage src={card4} alt="Image 4" /></ImageWrapper>
    <ImageWrapper className="img"><StyledImage src={card5} alt="Image 5" /></ImageWrapper> */}
    <ImageWrapper className="img main"><StyledImage src='https://genzixbackend.s3.ap-south-1.amazonaws.com/img2.webp' alt="Image 6" /></ImageWrapper>
    <ImageWrapper className="img main"><StyledImage src='https://genzixbackend.s3.ap-south-1.amazonaws.com/img.webp' alt="Image 7" /></ImageWrapper>
    <ImageWrapper className="img main"><StyledImage src='https://genzixbackend.s3.ap-south-1.amazonaws.com/img8.webp' alt="Image 8" /></ImageWrapper>
  </ImagesContainer>
));

export default Images;

{/* <div>
  {hiddenClass ? (
     <ImagesContainer className="images" ref={ref}>
     <ImageWrapper className="img"><StyledImage src={card1} alt="Card 1 design" /></ImageWrapper>
     <ImageWrapper className="img"><StyledImage src={card2} alt="Card 2 design" /></ImageWrapper>
     <ImageWrapper className="img "><StyledImage src={card6} alt="Card 3 design" /></ImageWrapper>
     <ImageWrapper className="img "><StyledImage src={card7} alt=" Card 4 design" /></ImageWrapper>
     <ImageWrapper className="img "><StyledImage src={card8} alt="Card 5 design" /></ImageWrapper>
     
   </ImagesContainer>
  ):(
     <ImagesContainer className="images" ref={ref}>
     <ImageWrapper className="img"><StyledImage src={card1} alt="Card 1 design" /></ImageWrapper>
     <ImageWrapper className="img"><StyledImage src={card2} alt="Card 2 design" /></ImageWrapper>
     <ImageWrapper className="img main"><StyledImage src={card6} alt="Card 3 design" /></ImageWrapper>
     <ImageWrapper className="img main"><StyledImage src={card7} alt=" Card 4 design" /></ImageWrapper>
     <ImageWrapper className="img main"><StyledImage src={card8} alt="Card 5 design" /></ImageWrapper>
     
   </ImagesContainer>
  )}
 </div> */}